import { render, staticRenderFns } from "./CheckboxOption.vue?vue&type=template&id=e5e106a4&scoped=true&shadow"
import script from "./CheckboxOption.vue?vue&type=script&lang=js&shadow"
export * from "./CheckboxOption.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e5e106a4",
  null
  ,true
)

export default component.exports